import { render, staticRenderFns } from "./humanities.vue?vue&type=template&id=39408580&scoped=true"
import script from "./humanities.vue?vue&type=script&lang=js"
export * from "./humanities.vue?vue&type=script&lang=js"
import style0 from "./humanities.vue?vue&type=style&index=0&id=39408580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39408580",
  null
  
)

export default component.exports